<template>
  <div class="calender-schedule-dialog-component">
    <div class="main-container">
      <only-text-media
        v-if="images.length === 0"
        v-show="showOnlyMediaModal"
        :hasLink="facebook && !!form.story_url"
        @save="saveSelect"
      ></only-text-media>
      <calender-schedule-media
        v-else
        :story="story"
        :class="{ 'form-hide': showMediaEditModal }"
        ref="media"
        :images="images"
        :publisherList="publisherList"
        v-show="showMediaModal"
      ></calender-schedule-media>
      <hi-dialog
        class="form-dialog"
        @close="close"
        v-show="showMainFormModal"
        :class="{ 'form-hide': showMediaEditModal }"
      >
        <div slot="title" class="form-title">
          <template v-if="switchSocialNetworkList.length > 1">
            <div
              v-for="network in showSocialNetworkList"
              :key="network.type"
              :class="{
                select: network.type === currentType,
                instagram: network.type === 'instagram',
                twitter: network.type === 'twitter',
                facebook: network.type === 'facebook',
              }"
              class="social-image-container"
            >
              <div
                @click="switchCurrentType(network.type)"
                class="social-image"
              ></div>
            </div>
            <ins-list
              type="mul"
              v-if="switchSocialNetworkList.length !== 3"
              filter="callback"
              :selectIds="allPublisherIds"
              :mulSocialNetworkFilter="false"
              :medias="images"
              @itemClick="mulUserClick"
            >
              <el-button
                class="add-user-btn"
                icon="el-icon-plus"
                round
                plain
              ></el-button>
            </ins-list>
          </template>
          <template v-else>
            {{ title }}
          </template>
        </div>
        <!--只有添加模式才显示publisher-->
        <div v-show="addModel" class="users-container">
          <div class="user-item" v-for="p in publisherList" :key="p.username">
            <div class="image" v-lazy:background-image="p.image" :key="p.image">
              <div v-if="p.socialNetwork === 1" class="ins-user-icon"></div>
              <div v-if="p.socialNetwork === 2" class="fb-page-user-icon"></div>
              <div
                v-if="p.socialNetwork === 3"
                class="fb-group-user-icon"
              ></div>
              <div v-if="p.socialNetwork === 4" class="tw-user-icon"></div>
            </div>
            <div class="username" v-show="publisherList.length === 1">
              {{ p.username }}
            </div>
          </div>
          <div class="add-user-container">
            <template v-if="multiPublisherDistribution">
              <ins-list
                type="mul"
                v-if="switchSocialNetworkList.length !== 1 || story"
                filter="login"
                :selectIds="form.publisherIds"
              >
                <el-button
                  class="add-user-btn"
                  icon="el-icon-plus"
                  round
                  plain
                ></el-button>
              </ins-list>
              <ins-list
                v-else
                type="mul"
                filter="callback"
                :mulSocialNetworkFilter="false"
                :medias="images"
                :selectIds="allPublisherIds"
                @itemClick="mulUserClick"
              >
                <el-button
                  class="add-user-btn"
                  icon="el-icon-plus"
                  round
                  plain
                ></el-button>
              </ins-list>
            </template>
            <el-button
              v-else
              class="add-user-btn"
              icon="el-icon-plus"
              @click.native="addUserBtnClick"
              round
              plain
            ></el-button>
          </div>
        </div>
        <div class="form-container">
          <hi-validate ref="form" :model="form" :rules="rules">
            <div v-if="story" class="story-img-container">
              <div v-for="img in images" :key="img.id">
                <media-crop-thumbnails
                  @click.native="showMediaModal = !showMediaModal"
                  :model="img"
                  :key="img.id"
                  class="story-img"
                ></media-crop-thumbnails>
              </div>
            </div>
            <div :class="{ 'top-container': !story }">
              <div class="caption" v-show="!story">
                <div v-if="images.length > 0" class="image">
                  <media-crop-thumbnails
                    @click.native="showMediaModal = !showMediaModal"
                    :model="images[0]"
                    class="image"
                  ></media-crop-thumbnails>
                  <div v-show="images.length > 1" class="mul-icon"></div>
                </div>
                <div v-else class="image">
                  <div class="tw-add" @click="showMediaLibrary"></div>
                </div>
                <hi-text-area
                  v-if="twitter"
                  ref="caption"
                  class="text-area"
                  :max="280"
                  v-model="form.caption"
                  socialNetwork="twitter"
                  placeholder="what's happening..."
                  @taBlur="validateUrl"
                  @taFocus="showCaptionDialog"
                ></hi-text-area>
                <hi-text-area
                  v-else
                  ref="caption"
                  class="text-area"
                  :max="max"
                  :filterNum="filterNum"
                  :socialNetwork="socialNetwork"
                  v-model="form.caption"
                  placeholder="write a caption..."
                  @taBlur="validateUrl"
                  @taFocus="showCaptionDialog"
                  filterText="#"
                ></hi-text-area>
              </div>
              <url
                :url="form.story_url"
                v-if="form.story_url && !story"
                @close="form.story_url = ''"
              ></url>
            </div>
            <div style="padding: 0 20px">
              <hi-form-item
                padding-l-r="0"
                v-if="hasDefaultTimePermission"
                :title="defaultTimeText"
              >
                <el-switch
                  @change="defaultTimeOpenChange"
                  v-model="defaultTime.send"
                ></el-switch>
              </hi-form-item>
              <hi-form-item
                class="form-item"
                padding-l-r="0"
                v-if="story && !showDefaultTime"
                @click="$refs.tz2.focus()"
                title="Time Zone"
              >
                <el-select
                  ref="tz2"
                  style="width: 200px"
                  v-model="form.tzName"
                  clearable
                  filterable
                  placeholder="None"
                >
                  <el-option
                    v-for="item in timezones"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </hi-form-item>
              <hi-form-item
                class="form-item"
                @click.stop="$refs.postTime.dateClick()"
                padding-l-r="0"
                v-show="!showDefaultTime"
                :title="story ? 'Upload Time' : 'Post Time'"
              >
                <hi-datetime
                  ref="postTime"
                  :clear-able="false"
                  v-model="form.postTime"
                  @focus="postTimeFocus"
                ></hi-datetime>
              </hi-form-item>
              <!--post 的 delete time- default time开启则不显示 免费用户也不显示-->
              <!-- <hi-form-item
                class="form-item"
                @click.stop="$refs.delTime.dateClick()"
                padding-l-r="0"
                v-show="!story && !showDefaultTime && !facebookGroup"
                title="Delete Time"
              >
                <hi-datetime
                  ref="delTime"
                  @itemClick="deleteTimeClick"
                  :readonly="!autoDeletePermission"
                  v-model="form.deleteTime"
                  @focus="delTimeFocus"
                ></hi-datetime>
              </hi-form-item> -->
              <!--story的 delete time -->
              <hi-form-item
                class="form-item"
                @click.stop="$refs.afterTime.click()"
                padding-l-r="0"
                v-show="story && !facebookGroup"
                title="Delete Time"
              >
                <form-timer
                  prefix="After"
                  ref="afterTime"
                  :readonly="!autoDeletePermission"
                  @itemClick="deleteTimeClick"
                  v-model="form.afterTime"
                  selectable-range="00:01:00 - 23:59:00"
                ></form-timer>
              </hi-form-item>
              <hi-form-item
                class="form-item"
                padding-l-r="0"
                @click.stop="$refs.tz1.focus()"
                v-if="!story && !showDefaultTime"
                title="Time Zone"
              >
                <el-select
                  ref="tz1"
                  style="width: 200px"
                  placement="right"
                  v-model="form.tzName"
                  clearable
                  filterable
                  placeholder="None"
                >
                  <el-option
                    v-for="item in timezones"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </hi-form-item>
              <hi-form-item
                padding-l-r="0"
                class="form-item"
                v-show="!this.showDefaultTime && !story && addModel"
                title="Repeat Time"
                @click="showRepeatTimeDialog"
                :model="repeatType"
              ></hi-form-item>
              <!-- 只有post ins 纯图片才会有tag people -->
              <hi-form-item
                class="form-item"
                padding-l-r="0"
                v-show="!story && instagram && !hasVideo"
                title="Tag People"
                :model="tagPeopleText"
                @click="showTagPeople"
              ></hi-form-item>
              <!--如果想显示tag product则必须为post且至少有一张图片 且该账号有ins tag product（大号）-->
              <!-- <hi-form-item
                class="form-item"
                padding-l-r="0"
                v-show="!story && hasImage && instagram"
                title="Tag Products"
                :model="tagProductsText"
                @click="showTagProducts"
              ></hi-form-item> -->
              <location-form
                v-show="!story && !facebook && !twitter"
                :validate="this.taggingPermission"
                v-model="form.location"
              ></location-form>
              <hi-form-item
                class="form-item"
                padding-l-r="0"
                v-show="!story && !facebookGroup"
                :title="firstCommentText"
                @click="showCommentDialog"
                v-model="form.firstComment"
                :readonly="!firstCommentPermission"
              ></hi-form-item>
              <hi-form-item
                class="form-item"
                padding-l-r="0"
                v-show="story && images.length > 1"
                title="Upload Interval"
              >
                <form-timer
                  :clear-able="false"
                  v-model="uploadInterval"
                  selectable-range="00:01:00 - 06:00:00"
                ></form-timer>
              </hi-form-item>
              <hi-form-item
                class="form-item"
                padding-l-r="0"
                v-show="!this.showDefaultTime && story && addModel"
                title="Repeat Time"
                @click="showRepeatTimeDialog"
                :model="repeatType"
              ></hi-form-item>
              <div v-show="story" class="story-container">
                <div class="title-container">
                  <div class="text">Story URL</div>
                  <el-tooltip
                    class="tooltip"
                    effect="dark"
                    placement="top-start"
                  >
                    <div slot="content" style="width: 300px; padding: 5px">
                      {{ storyTip }}
                    </div>
                    <div class="icon"></div>
                  </el-tooltip>
                </div>
                <input
                  :readonly="!storyUrlPermission"
                  @click="storyUrlClick"
                  v-model="form.story_url"
                  class="url-text"
                  placeholder="http://example.com"
                />
              </div>
            </div>
          </hi-validate>
        </div>
        <div class="bottom-container">
          <hi-button @click.native="submit">Done</hi-button>
        </div>
      </hi-dialog>
      <calender-schedule-caption
        :class="{ 'form-hide': showMediaEditModal }"
        ref="calenderScheduleCaption"
        :textarea="$refs.caption"
        :form="form"
        :socialNetwork="socialNetwork"
        :publisherId="form.publisherIds[0]"
        v-model="showCaptionModal"
      ></calender-schedule-caption>
      <calender-schedule-common
        :class="{ 'form-hide': showMediaEditModal }"
        ref="calenderScheduleCommon"
        :textarea="$refs.caption"
        :form="form"
        v-model="showCommentModal"
        :publisherId="form.publisherIds[0]"
      ></calender-schedule-common>
      <calender-schedule-tag-people
        :tags="userTags"
        :class="{ 'form-hide': showMediaEditModal }"
        v-if="showTagPeopleModal"
        :images="images"
      ></calender-schedule-tag-people>
      <calender-schedule-tag-people
        :tags="tagProducts"
        :class="{ 'form-hide': showMediaEditModal }"
        type="product"
        :images="images"
        v-if="showTagProductModal"
      ></calender-schedule-tag-people>
      <media-crop-group
        :images="images"
        type="filter"
        @close="showMediaEditModal = false"
        v-if="showMediaEditModal"
        :class="{ 'media-crop-hide': !showMediaEditModal }"
      ></media-crop-group>
      <calender-schedule-repeat
        :type.sync="repeatType"
        ref="repeat"
        :form="form"
        :class="{ 'form-hide': showMediaEditModal }"
        v-show="showRepeatTime"
      ></calender-schedule-repeat>
    </div>
  </div>
</template>

<style lang="less" scoped>
.add-user-btn {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  padding: 0;
  box-sizing: content-box;
  display: block;

  &.readonly {
    cursor: not-allowed;
  }
}
.form-title {
  display: flex;
  align-items: center;
  height: 49px;
  .add-user-btn {
    width: 28px;
    height: 28px;
    padding: 0 !important;
    margin: 0 5px;
  }
  .social-image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 49px;
    height: 49px;
    border-bottom: 3px solid transparent;
    &.select {
      .social-image {
        filter: grayscale(0);
      }
      &.instagram {
        border-color: #e74b6a;
      }
      &.facebook {
        border-color: #3b568f;
      }
      &.twitter {
        border-color: #1e96ed;
      }
    }
    &.instagram .social-image {
      background-image: url("../../../../../public/images/common/ins@3x.png");
    }
    &.facebook .social-image {
      background-image: url("../../../../../public/images/common/fb@3x.png");
    }
    &.twitter .social-image {
      background-image: url("../../../../../public/images/common/tw@3x.png");
    }
  }
  .social-image {
    width: 25px;
    height: 25px;
    background-size: contain;
    margin: 0 5px;
    filter: grayscale(100%);
    cursor: pointer;
    &:hover {
      opacity: 0.7;
    }
    &.instagram {
      background-image: url("../../../../../public/images/common/ins@3x.png");
    }
    &.facebook {
      background-image: url("../../../../../public/images/common/fb@3x.png");
    }
    &.twitter {
      background-image: url("../../../../../public/images/common/tw@3x.png");
    }
  }
}
.tw-add {
  width: 100%;
  height: 100%;
  background-image: url("../../../../../public/images/common/tw_add@3x.png");
  background-size: contain;
}
.calender-schedule-dialog-component {
  .media-crop-hide {
    top: calc(~"-100vh - 500px");
  }

  .form-hide {
    top: calc(~"100vh + 500px");
    position: fixed;
  }

  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;

  .main-container {
    display: flex;
    align-items: flex-start;

    .form-dialog {
      width: 480px;
      height: 730px;
      display: flex;
      flex-direction: column;

      .users-container {
        display: flex;
        overflow: auto;
        padding: 7px 20px;
        border-bottom: 1px solid #e5e5e5;

        .user-item {
          display: flex;
          align-items: center;
          margin-right: 15px;

          .image {
            height: 30px;
            width: 30px;
            border-radius: 50%;
            background-size: contain;
            background-position: center;
            position: relative;
          }

          .username {
            margin: 0 7px;
            font-size: 14px;
          }
        }

        .add-user-container {
          .add-user-btn {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            padding: 0;
            box-sizing: content-box;
            display: block;

            &.readonly {
              cursor: not-allowed;
            }
          }
        }
      }

      .story-img-container {
        overflow: auto;
        padding: 15px 20px;
        display: flex;
        border-bottom: 1px solid #e5e5e5;

        .story-img {
          width: 123px;
          height: 218px;
          margin-right: 20px;
        }
      }

      .form-container {
        flex: 1;
        overflow: auto;

        .form-item {
          cursor: pointer;
        }
        .top-container {
          border-bottom: 1px solid #e5e5e5;
        }
        .caption {
          display: flex;
          padding: 15px 20px;

          .image {
            width: 123px;
            height: 123px;
            background-size: cover;
            background-position: center;
            cursor: pointer;
            position: relative;
            background: #e5e5e5;

            .mul-icon {
              background-image: url("../../../../../public/images/library/album@3x.png");
              width: 25px;
              height: 25px;
              background-size: contain;
              background-position: center;
              position: absolute;
              right: 10px;
              top: 10px;
              z-index: 1;
            }
          }

          .text-area {
            flex: 1;
            margin-left: 15px;
            height: 123px;
          }
        }

        .story-container {
          height: 80px;
          padding: 10px 0;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          border-bottom: 1px solid #e6e6e6;
          font-size: 14px;

          .title-container {
            display: flex;
            align-items: center;

            .text {
            }

            .icon {
              width: 22px;
              height: 22px;
              background-image: url("../../../../../public/images/schedule_posts/error_grey@3x.png");
              background-size: contain;
              margin-left: 10px;
            }
          }

          .url-text {
            border: 0;
            font-size: 14px;
            color: #606266;

            &::placeholder {
              color: #d2d2d2;
              font-weight: 200;
            }
          }
        }
      }

      .bottom-container {
        border-top: 1px solid #e5e5e5;
        padding: 0 20px;
        height: 64px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: row-reverse;
      }
    }
  }
}
</style>

<script>
import hiDialog from "../../../common/dialog/Index.vue";
import { timezones } from "../../../../const/timezone";
import hiValidate from "../../../common/validate/Index.vue";
import hiFormItem from "../../../common/form/Index.vue";
import hiButton from "../../../common/button/Index";
import hiTextArea from "../../../common/form/TextArea.vue";
import calenderScheduleCaption from "./Caption.vue";
import calenderScheduleMedia from "./Media.vue";
import calenderScheduleCommon from "./Comment.vue";
import calenderScheduleTagPeople from "../tag_people/TagPeople";
import locationForm from "./Location.vue";
import insList from "../../../plan_header/ins_list/Index";
import moment from "moment-timezone";
import { mapGetters } from "vuex";
import {
  CURRENT_PUBLISHER_SIMPLE,
  CURRENT_USER_INFO_SIMPLE,
  TIMEZONE,
} from "../../../../store/mutation-types";
import {
  emptyScheduleForm,
  validatePost,
  initPostFormData,
  postForm,
  getDefaultPostTimes,
} from "../../../../service/post";
import { initValidate, showErrorMsg } from "../../../../utils/errors";
import MediaCropThumbnails from "../../crop/Thumbnail";
import _ from "lodash";
import FormTimer from "../../../common/form/Time";
import {
  permissionValidate,
  getCaptionComment,
  getSavedCaption,
} from "../../../../service/publisher";
import lockr from "lockr";
import hiDatetime from "../../../common/form/DateTime";
import CalenderScheduleRepeat from "./repeat/Repeat";
import { getVideoDuration } from "../../../../utils/media";
import { setCropImages } from "../../../../service/media";
import MediaCropGroup from "../../../../components/media/crop/Filter";
import OnlyTextMedia from "../../../../components/media/schedule/form/OnlyTextMedia";
import { httpString, getTextLength } from "../../../../utils/index";
import url from "../../../../components/common/form/Url";

export default {
  name: "ScheduleFormComponent",
  components: {
    MediaCropGroup,
    CalenderScheduleRepeat,
    hiDatetime,
    calenderScheduleMedia,
    hiDialog,
    hiValidate,
    hiFormItem,
    hiTextArea,
    hiButton,
    calenderScheduleCaption,
    calenderScheduleCommon,
    calenderScheduleTagPeople,
    locationForm,
    insList,
    MediaCropThumbnails,
    FormTimer,
    OnlyTextMedia,
    url,
  },
  props: {
    info: {
      type: Object,
      required: true,
    },
  },
  data() {
    const _this = this;
    return {
      typeOrder: [], // 记录多账号添加顺序
      timezones,
      storyTip:
        "Add Story URL only works if your Instagram supports this feature. If your Instagram is verified, or if you have over 10,000 followers and an Instagram business profile, you can add links to Instagram Stories that users can visit by just “swiping up” on the screen",
      dateTimeFormat: "YYYY-MM-DD HH:mm:ss",
      showMainFormModal: true, // 表单主体是否显示
      showCaptionModal: false, // 表单caption是否显示
      showCommentModal: false, // 表单comment是否显示
      showMediaModal: false, // 选择media是否显示
      showMediaEditModal: false, // 是否显示多媒体编辑的弹框
      showTagPeopleModal: false, // tag people是否显示
      showTagProductModal: false, // tag product是否显示
      showOnlyMediaModal: false, // only text所展示的media library
      showRepeatTime: false, // repeatTime是否显示
      defaultTime: null, // default time是否
      model: "add",
      images: [],
      form: {},
      forms: [],
      currentType: "",
      repeatType: "Never", // repeat 的类型
      uploadInterval: "00:01",
      rules: {
        firstComment: [
          {
            validator(rule, value, callback1) {
              if (_this.twitter) {
                if (_this.filterNum > 280) {
                  callback1("Cannot have more than 280 characters on Twitter");
                } else {
                  callback1();
                }
              }
              if (_this.filterNum > 30) {
                callback1(
                  "Too many hashtags. Instagram has 30 hashtags limitation."
                );
              } else {
                callback1();
              }
            },
          },
        ],
        story_url: [
          {
            type: "url",
            message:
              "Invalid URL Format. Must contain http:// or https:// in the beginning.",
          },
        ],
      },
    };
  },
  watch: {
    "form.publisherIds"(val) {
      if (val.length === 0) {
        // 同时清空当前类型的历史
        const delIndex = this.typeOrder.findIndex(
          (t) => t === this.currentType
        );
        if (delIndex !== -1) {
          this.typeOrder.splice(delIndex, 1);
        }
        this.switchCurrentType(this.switchSocialNetworkList[0].type);
      }
    },
    "form.deleteTime"(val) {
      // 如果posttime改变则影响全部
      for (let i = 0; i < this.forms.length; i++) {
        this.forms[i].deleteTime = val;
      }
    },
    "defaultTime.send"(val) {
      // 如果关闭默认时间则重置发送和删除时间
      if (!val) {
        this.form.postTime = moment()
          .tz(this.timezone)
          .add("m", 5)
          .format(this.dateTimeFormat);
        this.form.tzName = this.timezone;
        this.form.deleteTime = "";
      }
    },
    showModal(val) {
      this.$emit("updateShow", val);
      if (val) {
        this.initFormData();
      }
    },
    /**
     * 监听时区变化，动态更新post time 和delete time
     */
    "form.tzName"(val, old) {
      // 初次加载old 为undefined
      if (old === undefined) return;
      // 时区变化更新post time 和 delete time
      if (this.form.deleteTime) {
        this.form.deleteTime = moment
          .tz(this.form.deleteTime, old)
          .tz(val)
          .format(this.dateTimeFormat);
      }
      if (this.form.postTime) {
        this.form.postTime = moment
          .tz(this.form.postTime, old)
          .tz(val)
          .format(this.dateTimeFormat);
        // 防止时间早于当前时间
        if (moment().isAfter(this.form.postTime)) {
          this.form.postTime = moment()
            .tz(this.timezone)
            .add("m", 5)
            .format(this.dateTimeFormat);
        }
      }
      // 如果posttime改变则影响全部
      for (let i = 0; i < this.forms.length; i++) {
        this.forms[i].tzName = val;
      }
    },
    /**
     * 监听post time变化
     */
    "form.postTime"(val) {
      // 当前选中的删除时间
      const delDateTime = moment(this.form.deleteTime);
      const postDateTime = moment(val);
      // 如果发送时间比删除时间还晚则自动更新删除时间
      if (moment(delDateTime).isBefore(postDateTime)) {
        // 在posttime时间基础上加5分钟
        this.form.deleteTime = moment(val)
          .add("m", 5)
          .format(this.dateTimeFormat);
      }
      // 如果posttime改变则影响全部
      for (let i = 0; i < this.forms.length; i++) {
        this.forms[i].postTime = val;
      }
    },
    "form.caption"(val) {
      // 自动将当前值填写到还未显示的类型中
      for (let form of this.forms) {
        if (form.publisherIds.length === 0) {
          form.caption = val;
        }
      }
    },
    "form.comment"(val) {
      // 自动将当前值填写到还未显示的类型中
      for (let form of this.forms) {
        if (form.publisherIds.length === 0) {
          form.firstComment = val;
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
      timezone: TIMEZONE,
      currentPublisher: CURRENT_PUBLISHER_SIMPLE,
    }),
    publisher() {
      if (this.form && this.form.publisherIds && this.form.publisherIds[0]) {
        return this.user.linkedInstagramList.find(
          (l) => l.publisherId === this.form.publisherIds[0]
        );
      } else {
        return this.currentPublisher;
      }
    },
    // 计算所有选中的id
    allPublisherIds() {
      const publisherIds = [];
      this.forms.forEach((f) => {
        publisherIds.push(...f.publisherIds);
      });
      return publisherIds;
    },
    socialNetwork() {
      if (this.twitter) {
        return "twitter";
      } else if (this.instagram) {
        return "instagram";
      } else if (this.facebookPage) {
        return "facebookPage";
      } else if (this.facebookGroup) {
        return "facebookGroup";
      }
    },
    switchSocialNetworkList() {
      const types = this.forms
        .filter((f) => f.publisherIds.length > 0)
        .map((f) => {
          return {
            type: f.type,
            select: f.type === this.currentType,
          };
        });
      return types;
    },
    // 展示上方多账号类型的tab 主要是在switchSocialNetworkList顺序
    showSocialNetworkList() {
      return this.typeOrder.map((t) =>
        this.switchSocialNetworkList.find((s) => s.type === t)
      );
    },
    max() {
      if (this.twitter) {
        return 280;
      } else {
        return 30;
      }
    },
    firstCommentText() {
      if (this.twitter) {
        return "Add First Reply";
      } else {
        return "Add First Comment";
      }
    },
    showFirstComment() {
      // story类型必然没有
      if (this.story) {
        return false;
      }
      // 判断多选中是否存在一个group 如果有就不显示first comment
      if (this.currentType === "facebook") {
        const publsiherList = this.form.publisherIds.map((pid) =>
          this.linkedInstagramList.find((l) => l.publisherId === pid)
        );
        const hasGroup = publsiherList.find((p) => p.socialNetwork === 2);
        if (hasGroup) {
          return false;
        }
      }
      return true;
    },
    facebookPage() {
      if (this.currentType === "facebook") {
        return !this.facebookGroup;
      }
      return false;
    },
    facebookGroup() {
      const selectPublisherList = this.form.publisherIds.map((publisherId) => {
        return this.user.linkedInstagramList.find(
          (l) => l.publisherId === publisherId
        );
      });
      const hasPage = selectPublisherList.find((p) => p.socialNetwork === 2);
      // group没有del time 比较特殊，所以只有全是group才按group处理
      return (
        this.currentType === "facebook" &&
        selectPublisherList.length > 0 &&
        !hasPage
      );
    },
    twitter() {
      return this.currentType === "twitter";
    },
    instagram() {
      return this.currentType === "instagram";
    },
    facebook() {
      return this.currentType === "facebook";
    },
    /**
     * 获取当前登录人权限
     */
    permission() {
      return this.publisher.permissions;
    },
    /**
     * 自动删除权限
     */
    autoDeletePermission() {
      return this.permission.auto_delete;
    },
    /**
     * 多账号发布权限
     */
    multiPublisherDistribution() {
      return (
        this.permission.multi_publisher_distribution &&
        this.tagProducts.length === 0
      );
    },
    /**
     * story url权限
     */
    storyUrlPermission() {
      return this.permission.story_url;
    },
    /**
     * first comment权限
     */
    firstCommentPermission() {
      return this.permission.first_comment;
    },
    /**
     * repeat 权限
     */
    repeatPermission() {
      return this.permission.repeating_schedule;
    },
    /**
     * 是否ins给予tag product权限
     */
    InsTagProductPermission() {
      return this.publisher.socialCanTagProducts;
    },
    /**
     * tag people 和add location 权限
     */
    taggingPermission() {
      return this.permission.tagging;
    },
    /**
     *drag 权限
     */
    dragPermission() {
      return this.permission.drag_and_drop;
    },
    /**
     * 是否为story发送
     */
    story() {
      return this.info.mediaType === 3;
    },
    /**
     * 标题
     */
    title() {
      if (this.story) {
        return "Story";
      } else {
        return "Schedule";
      }
    },
    /**
     * 是否显示默认发送时间
     */
    showDefaultTime() {
      // 如果没设置过defaultTime不显示
      if (!this.defaultTime) {
        return false;
      }
      // 如果没开启defaultTime不显示
      if (!this.defaultTime.open) {
        return false;
      }
      // 如果没开启defaultTime不显示
      if (!this.defaultTime.send) {
        return false;
      }
      return true;
    },
    /**
     * 是否有default time 权限
     */
    hasDefaultTimePermission() {
      // 如果没设置过defaultTime不显示
      if (!this.defaultTime) {
        return false;
      }
      if (!this.defaultTime.open) {
        return false;
      }
      return true;
    },
    /**
     * 计算将要发送的时间
     */
    defaultSendTime() {
      if (!this.showDefaultTime) {
        return null;
      }
      const times = getDefaultPostTimes({
        type: this.info.mediaType === 3 ? "story" : "post",
        publisherId: this.currentPublisher.publisherId,
      });
      return times[0];
    },
    defaultTimeText() {
      let text = "Default Post Time";
      if (!this.showDefaultTime) {
        return text;
      }
      text += ` at ${this.defaultSendTime.format("HH:mm ddd MMM D")}`;
      return text;
    },
    /**
     * 所有的user tag
     */
    userTags() {
      let tags = [];
      this.images.forEach((img) => {
        if (img.usertags) {
          img.usertags.forEach((tag) => {
            // 查看是否存在重复项
            const index = tags.findIndex((t) => t.user_id === tag.user_id);
            if (index === -1) {
              tags.push(tag);
            }
          });
        }
      });
      return tags;
    },
    /**
     * 格式化tag people
     */
    tagPeopleText() {
      if (this.userTags.length > 1) {
        return `${this.userTags.length} People`;
      } else if (this.userTags.length === 1) {
        return this.userTags[0].username;
      } else {
        return "";
      }
    },
    /**
     * 计算tag products 文案
     */
    tagProductsText() {
      if (this.tagProducts.length > 0) {
        return `${this.tagProducts.length} Products`;
      } else {
        return "";
      }
    },
    /**
     * 计算product tag
     */
    tagProducts() {
      let tags = [];
      this.images.forEach((img) => {
        if (img) {
          img.product_tags.forEach((tag) => {
            // 查看是否存在重复项
            const index = tags.findIndex((t) => t.id === tag.id);
            if (index === -1) {
              tags.push(tag);
            }
          });
        }
      });
      return tags;
    },
    /**
     * 是否为添加模式
     */
    addModel() {
      return this.model === "add";
    },
    /**
     * 计算#出现次数
     * @returns {number}
     */
    filterNum() {
      const caption = this.form.caption || "";
      const firstComment = this.form.firstComment || "";
      const text = caption + firstComment;
      if (this.twitter) {
        return getTextLength({ text, socialNetwork: "twitter" });
      }
      const find = [...text].filter((v) => {
        return v === "#";
      });
      return find.length;
    },
    // 计算当前选中publisher的信息
    publisherList() {
      if (!this.form.publisherIds) {
        return [];
      }
      return this.form.publisherIds.map((p) => {
        return this.user.linkedInstagramList.find((l) => l.publisherId === p);
      });
    },
    /**
     * 是否至少存在一张图片(tag product必须存在一张图片)
     */
    hasImage() {
      return this.images.findIndex((m) => m.type === 1) !== -1;
    },
    hasVideo() {
      return this.images.findIndex((i) => i.type === 2) !== -1;
    },
  },
  methods: {
    switchCurrentType(type) {
      this.currentType = type;
      this.form = this.forms.find((f) => f.type === type);
    },
    // 单network用户点击回调
    mulUserClick(publisherIds) {
      console.log("mulUserClick publisherIds", publisherIds);
      // 情况publisher选项
      this.forms.forEach((f) => {
        f.publisherIds = [];
      });
      // 判断所点击的用户是否均为同一类型
      const publisherList = publisherIds.map((p) => {
        return this.user.linkedInstagramList.find((l) => l.publisherId === p);
      });
      console.log("mulUserClick publisherList", publisherList);
      // 获取当前选中项的所有类型
      const hasIns = publisherList.find((p) => p.socialNetwork === 1);
      const hasFb = publisherList.find(
        (p) => p.socialNetwork === 2 || p.socialNetwork === 3
      );
      const hasTw = publisherList.find((p) => p.socialNetwork === 4);
      if (hasIns) {
        // 判断如果存在则不进行插入
        const oldIns = this.typeOrder.find((t) => t === "instagram");
        if (!oldIns) {
          this.typeOrder.push("instagram");
        }
      } else {
        const removeIndex = publisherList.findIndex(
          (p) => p.socialNetwork === 1
        );
        if (removeIndex !== -1) {
          this.typeOrder.splice(removeIndex, 1);
        }
      }
      if (hasFb) {
        // 判断如果存在则不进行插入
        const oldFb = this.typeOrder.find((t) => t === "facebook");
        if (!oldFb) {
          this.typeOrder.push("facebook");
        }
      } else {
        const removeIndex = publisherList.findIndex(
          (p) => p.socialNetwork === 2 || p.socialNetwork === 3
        );
        if (removeIndex !== -1) {
          this.typeOrder.splice(removeIndex, 1);
        }
      }
      if (hasTw) {
        // 判断如果存在则不进行插入
        const oldTw = this.typeOrder.find((t) => t === "twitter");
        if (!oldTw) {
          this.typeOrder.push("twitter");
        }
      } else {
        const removeIndex = publisherList.findIndex(
          (p) => p.socialNetwork === 4
        );
        if (removeIndex !== -1) {
          this.typeOrder.splice(removeIndex, 1);
        }
      }
      publisherList.forEach((p) => {
        if (p.socialNetwork === 1) {
          this.forms[0].publisherIds.push(p.publisherId);
        } else if (p.socialNetwork === 2 || p.socialNetwork === 3) {
          this.forms[1].publisherIds.push(p.publisherId);
        } else if (p.socialNetwork === 4) {
          this.forms[2].publisherIds.push(p.publisherId);
        }
      });
    },
    validateUrl() {
      const url = httpString(this.form.caption);
      if (this.facebook && url && this.images.length === 0) {
        let address = url[0];
        if (address.substr(0, 4) !== "http") {
          address = `http://${address}`;
        }
        this.form.story_url = address;
      }
    },
    async showMediaLibrary() {
      try {
        const facebook = this.forms.find(
          (f) => f.type === "facebook" && f.publisherIds.length > 0
        );
        // 遍历是否存在facebook
        debugger;
        if (facebook && facebook.story_url) {
          await Promise.reject(
            initValidate({
              msg: "You can‘t add your own media when you share link.",
            })
          );
        }
        this.showOnlyMediaModal = true;
      } catch (e) {
        showErrorMsg(e);
      }
    },
    /**
     * 验证视频播放时长不能超过1分钟
     */
    async validateVideoDuration() {
      // 遍历所有多媒体，判断是否存在超过60秒的视频
      for (let index = 0; index < this.images.length; index++) {
        const media = this.images[0];
        // 说明是视频
        if (media.type === 2) {
          const duration = await getVideoDuration({ url: media.url });
          if (duration > 60) {
            console.log(`发现视频时长超过60秒(${duration})`, media);
            this.$bus.$emit("showDownload", {
              msg: "This video is more than 60 seconds. Apphi can only post video in less than 60 seconds. You can try to do it on Apphi APP",
            });
            return false;
          }
        }
      }
      return true;
    },
    /**
     * 添加多账号按钮点击事件
     */
    async addUserBtnClick() {
      // 选人的时候强制关闭tag product
      this.showTagProductModal = false;
      // 判断如果已经存在一个tag product则不能添加
      if (this.tagProducts.length > 0) {
        await this.$alert.show({
          text: "Tag Product is not available when you apply to multiple Instagram.",
          yesText: "OK",
        });
        return;
      }
      // 如果没有权限则弹出对应升级提示
      if (!this.multiPublisherDistribution) {
        await permissionValidate({ type: "basic" });
      }
    },
    /**
     * 删除按钮点击回调
     */
    async deleteTimeClick() {
      if (!this.autoDeletePermission) {
        await permissionValidate({ type: "full" });
      }
    },
    /**
     * storyUrl点击事件
     */
    async storyUrlClick() {
      if (!this.storyUrlPermission) {
        await permissionValidate({ type: "pro" });
      }
    },
    /**
     * default time 开关发生变化时进行保存
     */
    defaultTimeOpenChange() {
      const sendInfo = lockr.get(this.defaultTime.id, {});
      sendInfo.send = this.defaultTime.send;
      lockr.set(this.defaultTime.id, sendInfo);
    },
    /**
     * 打开裁切组件
     */
    openCropGroup() {
      this.showMediaEditModal = true;
    },
    closeCropGroup() {
      this.showMediaEditModal = false;
    },
    /**
     * 关闭按钮点击事件
     */
    close() {
      this.$bus.$emit("closeScheduleForm");
    },
    /**
     * 删除时间焦点事件
     */
    postTimeFocus() {
      if (!this.form.postTime) {
        this.form.postTime = moment()
          .tz(this.form.tzName)
          .add("m", 5)
          .format(this.dateTimeFormat);
      }
    },
    /**
     * 删除时间焦点事件
     */
    delTimeFocus() {
      if (this.form.deleteTime === "" || !this.form.deleteTime) {
        this.form.deleteTime = moment
          .tz(this.form.postTime, this.form.tzName)
          .add("m", 5)
          .format(this.dateTimeFormat);
      }
    },
    closeRightModal() {
      this.showCaptionModal = false;
      this.showCommentModal = false;
      this.showTagPeopleModal = false;
      this.showTagProductModal = false;
      this.showRepeatTime = false;
    },
    /**
     * 展示Caption对话框
     */
    showCaptionDialog() {
      this.closeRightModal();
      this.showCaptionModal = true;
    },
    /**
     * 展示First Comment对话框
     */
    async showCommentDialog() {
      if (!this.firstCommentPermission) {
        await permissionValidate({ type: "full" });
      } else {
        if (this.showCommentModal) {
          this.showCommentModal = false;
          return;
        }
        this.closeRightModal();
        this.showCommentModal = true;
      }
    },
    /**
     * 显示repeat time弹出框
     */
    async showRepeatTimeDialog() {
      try {
        if (this.story && this.images.length > 1) {
          await Promise.reject(
            initValidate({
              msg: "Repeat schedule feature is not available when you have multiple media.",
            })
          );
          return;
        }
        if (this.showRepeatTime) {
          this.showRepeatTime = false;
          return;
        }
        this.closeRightModal();
        this.showRepeatTime = true;
      } catch (e) {
        showErrorMsg(e);
      }
    },
    async showTagPeople() {
      // tag product 和 tag people 互斥，2个功能不能同时使用
      if (this.tagProducts.length > 0) {
        await this.$alert.show({
          text: `Tagging people and products in the same post isn't available.`,
          yesText: `OK`,
        });
        return;
      }
      if (this.showTagPeopleModal) {
        this.showTagPeopleModal = false;
        return;
      }
      this.closeRightModal();
      this.showTagPeopleModal = true;
    },
    /**
     * 打开product
     */
    async showTagProducts() {
      if (!this.InsTagProductPermission) {
        try {
          await this.$confirm.show({
            text: "Your Instagram does not support this feature.",
            yesText: "OK",
            cancelText: "Help",
            showClose: false,
          });
        } catch (e) {
          if (e === "cancel") {
            window.open(process.env.VUE_APP_CONTACT_US, "_blank");
          }
        }
        return;
      }
      // 多账号不能tag people
      if (this.form.publisherIds.length > 1) {
        await this.$alert.show({
          text: "Tag Product is not available when you apply to multiple Instagram.",
          yesText: "OK",
        });
        return;
      }
      // tag product 和 tag people 互斥，2个功能不能同时使用
      if (this.userTags.length > 0) {
        await this.$alert.show({
          text: `Tagging people and products in the same post isn't available.`,
          yesText: `OK`,
        });
        return;
      }
      if (this.showTagProductModal) {
        this.showTagProductModal = false;
        return;
      }
      this.closeRightModal();
      this.showTagProductModal = true;
    },

    /**
     * 计算是否需要弹出升级逻辑
     */
    async validateUpgrade({ repeatTime }) {
      // 如果是编辑状态则不进行验证了
      if (this.info.type === "edit") {
        return true;
      }
      // 计算当前发送回占用多少autopost
      let autoNum = 1;
      if (this.story) {
        autoNum = this.images.length;
      }
      const postList = this.form.publisherIds.map((publisherId) => {
        const publisher = this.user.linkedInstagramList.find(
          (p) => p.publisherId === publisherId
        );
        return {
          publisherId,
          num: repeatTime.length * autoNum,
          id: publisher.id,
        };
      });
      const success = await validatePost({ postList });
      return success;
    },
    async submit() {
      // 判断当前用户是否为无密码账号，如果有则弹出登录提示
      if (this.publisher.status === 2) {
        if (this.publisher.socialNetwork === 1) {
          this.$bus.$emit("showAddIns", {
            username: this.publisher.username,
            insType: "verify",
          });
        } else if (this.publisher.socialNetwork === 2) {
          this.$bus.$emit("showAddFacebookPage", {});
        } else if (this.currentPublisher.socialNetwork === 3) {
          this.$bus.$emit("showAddFacebookGroup", {});
        } else if (this.currentPublisher.socialNetwork === 4) {
          this.$bus.$emit("showAddTwitter", {});
        }
        return;
      }
      const hasTwitter =
        this.switchSocialNetworkList.findIndex((s) => s.type === "twitter") !==
        -1;
      // 判断多用户是否存在twitter用户
      // 判断如果是twitter 则限制只能是单视频和4图片
      if (hasTwitter) {
        let showMsg = false;
        const hasVideo = this.images.find((i) => i.type === 2);
        if (hasVideo && this.images.length > 1) {
          showMsg = true;
        }
        if (this.images.length > 4) {
          showMsg = true;
        }
        if (showMsg) {
          await this.$alert.show({
            text: "Only supports 1 video or max 4 photos on Twitter.",
            yesText: "OK",
          });
          return;
        }
      }
      // ins必须至少有一个多媒体文件
      const hasIns =
        this.switchSocialNetworkList.findIndex(
          (s) => s.type === "instagram"
        ) !== -1;
      if (hasIns && this.images.length === 0) {
        await this.$alert.show({
          text: "Must add photo or video for Instagram.",
          yesText: "OK",
        });
        return;
      }
      // 检测当选择的ins时，是否存在单图超20 tag poeple 多图超15的情况
      // if (hasIns && this.images.length > 0) {
      //   debugger
      //   if (this.images.length === 1 && this.userTags.length > 20) {
      //     await this.$alert.show({
      //       text: 'Too many tags. Instagram allows up to 20 people tags in one post.',
      //       yesText: 'OK'
      //     })
      //     return
      //   }
      //   if (this.images.length > 1 && this.userTags.length > 15) {
      //     await this.$alert.show({
      //       text: 'Too many tags. Instagram allows up to 15 people tags in one post.',
      //       yesText: 'OK'
      //     })
      //     return
      //   }
      // }
      // 多媒体和caption至少要输入一个
      let showEmptyErrorMsg = false;
      this.forms.forEach((f) => {
        if (showEmptyErrorMsg) {
          return false;
        }
        // 多媒体和caption都为空则提示
        if (
          f.publisherIds.length !== 0 &&
          this.images.length === 0 &&
          !f.caption
        ) {
          showEmptyErrorMsg = true;
        }
      });
      if (showEmptyErrorMsg) {
        await this.$alert.show({
          text: "Missing description on your schedule.",
          yesText: "OK",
        });
        return;
      }
      // 验证drag权限
      if (this.info.fromType === "drag" && !this.dragPermission) {
        await permissionValidate({ type: "full" });
      }
      // 验证tag people 权限
      if (this.userTags.length > 0 && !this.taggingPermission) {
        await permissionValidate({ type: "full" });
        return;
      }
      // 判断当前选中的所有账号是否全都可以正常发布

      let loading;
      try {
        loading = this.$loading();
        let repeatTime;
        // 先进行表单验证
        await this.$refs.form.validate();
        // 检测如果有Ins则必须有图片
        const postHasIns = this.switchSocialNetworkList.find(
          (n) => n.type === "instagram"
        );
        if (postHasIns && this.images === 0) {
          await Promise.reject(
            initValidate({
              msg: "Cannot have more than 2200 characters on Instagram.",
            })
          );
        }
        const success = await this.validateVideoDuration();
        if (success) {
          for (let i = 0; i < this.forms.length; i++) {
            const form = this.forms[i];
            // 如果publisher不存在则不发送
            if (this.forms[i].publisherIds.length === 0) {
              continue;
            }
            const customRepeatTime = this.$refs.repeat.getTimes();
            if (this.showDefaultTime) {
              repeatTime = [
                {
                  postTime: this.defaultSendTime.format("YYYY-MM-DD HH:mm"),
                  deleteTime: "",
                },
              ];
            } else {
              if (customRepeatTime) {
                repeatTime = customRepeatTime;
              } else {
                repeatTime = [
                  {
                    postTime: form.postTime,
                    deleteTime: form.deleteTime,
                  },
                ];
              }
            }
            // 防止ins账号字符超过2200
            if (form.type === "instagram") {
              const captionTextLength = getTextLength({
                text: form.caption,
              });
              if (captionTextLength > 2200) {
                await Promise.reject(
                  initValidate({
                    msg: "Cannot have more than 2200 characters on Instagram.",
                  })
                );
              }
              const commentTextLength = getTextLength({
                text: form.firstComment,
              });
              if (commentTextLength > 2200) {
                await Promise.reject(
                  initValidate({
                    msg: "Cannot have more than 2200 characters on Instagram.",
                  })
                );
              }
            }
            // 如果有开启default time则repeat无效
            if (repeatTime && repeatTime.length === 0) {
              await Promise.reject(
                initValidate({
                  msg: "Invalid repeat schedule date. Please check again.",
                })
              );
            }
            // 如果发现是repeat (勾选了repeat 同时没选择default time)
            if (!this.showDefaultTime && customRepeatTime) {
              // 验证是否有对应权限
              if (!this.repeatPermission) {
                await permissionValidate({ type: "full" });
                return;
              }
            }
            // 验证时间是否存在不合理的情况
            const firstPostTime = moment.tz(
              repeatTime[0].postTime,
              form.tzName
            );
            if (firstPostTime.isBefore(moment())) {
              await Promise.reject(
                initValidate({
                  msg: "Scheduled post time must be greater than current time.",
                })
              );
            }
            if (!this.showDefaultTime && customRepeatTime) {
              // 验证当前选中人是否有足够数量的auto post
              const publisherId = form.publisherIds[0];
              const publisher = this.user.linkedInstagramList.find(
                (link) => link.publisherId === publisherId
              );
              // 计算当前发送回占用多少autopost
              let autoNum = 1;
              if (this.story) {
                autoNum = this.images.length;
              }
              if (publisher.autopostRemaining < autoNum * repeatTime.length) {
                await this.$confirm.show({
                  title: "No Enough Schedules",
                  text: `@${publisher.username} only has ${
                    publisher.autopostRemaining
                  } free schedules left for this month. There are ${
                    autoNum * repeatTime.length
                  } repeat schedules. Please upgrade your plan and add this Instagram to unlimited schedules.`,
                  yesText: this.$t("common.upgrade"),
                  cancelText: "Later",
                });
                this.$router.push({ name: "UpgradePage" });
              }
            }
            // 上传图片
            const upgrade = await this.validateUpgrade({ repeatTime });
            if (!upgrade) {
              return;
            }
            let baseForm = {
              form: form,
              mediaList: this.images,
              repeatTime,
            };
            let forms = [];
            repeatTime.forEach((r) => {
              r.tzName = form.tzName;
              r.afterTime = form.afterTime;
            });
            if (this.story) {
              baseForm.type = "story";
              // 添加story
              // story模式如果多图则拆分
              for (let imgIndex in this.images) {
                const form = _.cloneDeep(baseForm);
                const img = this.images[imgIndex];
                let uploadIntervalTime = 0;
                if (this.images.length > 1) {
                  const uploadIntervalDateTime = moment(
                    this.uploadInterval,
                    "HH:mm"
                  );
                  uploadIntervalTime =
                    uploadIntervalDateTime.hours() * 60 +
                    uploadIntervalDateTime.minutes();
                }
                form.form.postTime = moment
                  .tz(form.form.postTime, form.form.tzName)
                  .add("m", imgIndex * uploadIntervalTime);
                form.mediaList = [img];
                forms.push(form);
              }
            } else {
              baseForm.type = "post";
              forms = [baseForm];
            }
            if (this.showDefaultTime && this.defaultTime.send) {
              // 重新更新default信息(上次发送时间)
              const sendTime = moment
                .tz(
                  this.defaultSendTime.format("YYYY-MM-DD HH:mm"),
                  form.tzName
                )
                .format();
              lockr.set(this.defaultTime.id, {
                send: this.defaultTime.send,
                sendTime,
              });
            }
            // 如果是编辑则等待loading结束后关闭不走upload
            if (this.model === "edit") {
              const formatPostForm = initPostFormData({ forms });
              const promiseList = formatPostForm.map((f) =>
                postForm({ type: this.story ? "story" : "post", item: f })
              );
              const all = await Promise.all(promiseList);
              all.forEach((item) => {
                this.$bus.$emit("scheduleSuccess", item, this.info);
              });
            } else {
              // story需要拆成多个form提交
              this.$bus.$emit("uploadSchedule", {
                forms,
                id: this.info.uuid,
                info: this.info,
              });
            }
          }
          // 添加成功后关闭页面
          this.$bus.$emit("uploadCallback", { info: this.info });
          this.close();
          this.$toast.show({ message: this.$t("common.success") });
        }
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    },
    async saveSelect(image) {
      const loading = this.$loading();
      try {
        const images = [image];
        let percentage;
        if (images.length > 0) {
          // 获取每个多媒体图片，视频则放弃
          await setCropImages({ images, percentage });
        }
        this.images = images;
      } catch (e) {
        console.error(e);
        showErrorMsg(e);
        this.close();
      } finally {
        loading.close();
      }
    },
  },
  async created() {
    // 发送分为3种类型 这里直接计算中3种类型的表单数据
    const types = ["instagram", "facebook", "twitter"];
    // 模拟数据 显示裁切图片modal
    const loading = this.$loading();
    try {
      const images = _.cloneDeep(this.info.images);
      let percentage;
      // 判断如果是story则强制锁定裁切比例
      if (this.info.mediaType === 3) {
        percentage = 123 / 218;
        images.forEach((img) => {
          img.crop.lock = true;
          img.crop.percentage = percentage;
        });
      }
      if (images.length > 0) {
        // 获取每个多媒体图片，视频则放弃
        await setCropImages({ images, percentage });
      }
      this.images = images;
      this.forms = [];
      types.forEach((t) => {
        let form = _.cloneDeep(this.info.form);
        // 添加一个新的post或者story
        if (this.info.type === "new") {
          this.model = "add";
          form = emptyScheduleForm();
          // 如果是schedule则判断权限并给予caption 和 comment
          if (this.info.fromType === "schedule") {
            if (this.info.mediaType !== 3) {
              // story 禁止填充default caption comment
              const { caption, firstComment } = getCaptionComment({
                type: "schedule",
              });
              form.caption = caption;
              form.firstComment = firstComment;
            }
          } else if (this.info.fromType === "drag") {
            form.caption = this.info.tempForm.caption;
            form.firstComment = this.info.tempForm.firstComment;
          }
        } else if (this.info.type === "again") {
          this.model = "add";
          // 如果是再次发送则删除id，因为有id说明是修改
          form.id = undefined;
          form.deleteTime = null;
          form.postTime = emptyScheduleForm().postTime;
        } else if (this.info.type === "edit") {
          this.model = "edit";
          // 格式化日期当当前设置时间日期
          form.postTime = moment
            .tz(form.postTime, form.tzName)
            .format("YYYY-MM-DD HH:mm:ss");
          // 编辑状态
          if (!form.deleteTime) form.deleteTime = "";
        } else if (this.info.type === "saved") {
          form.id = undefined;
          form.deleteTime = null;
          form.postTime = emptyScheduleForm().postTime;
          this.model = "add";
          form.tzName = this.timezone;
          // 如果存在默认设置的初始值则显示初始值，其他情况自动拼接
          if (this.info.tempForm) {
            form.caption = this.info.tempForm.caption;
            form.firstComment = this.info.tempForm.firstComment;
          } else {
            const { caption, firstComment } = getCaptionComment({
              type: "search",
            });
            form.caption = getSavedCaption({
              username: this.info.user.social_username,
              caption: form.caption,
              defaultCaption: caption,
            });
            form.firstComment = firstComment;
          }
        }
        form.type = t;
        const currentPublisher = this.user.linkedInstagramList.find(
          (l) => l.publisherId === this.publisher.publisherId
        );
        // 当前用户为Ins则
        if (currentPublisher.socialNetwork === 1 && t === "instagram") {
          form.publisherIds = [this.publisher.publisherId];
        } else if (
          (currentPublisher.socialNetwork === 2 ||
            currentPublisher.socialNetwork === 3) &&
          t === "facebook"
        ) {
          form.publisherIds = [this.publisher.publisherId];
        } else if (currentPublisher.socialNetwork === 4 && t === "twitter") {
          form.publisherIds = [this.publisher.publisherId];
        } else {
          form.publisherIds = [];
        }
        // 切换当前发送类型
        if (form.publisherIds.length !== 0) {
          this.currentType = t;
        }
        this.forms.push(form);
      });
      // 判断当且切换的类型
      if (this.currentType === "instagram") {
        this.form = this.forms[0];
      } else if (this.currentType === "facebook") {
        this.form = this.forms[1];
      } else if (this.currentType === "twitter") {
        this.form = this.forms[2];
      }
      if (this.info.only) {
        this.showMainFormModal = false;
        // 显示裁切组件
        if (this.info.only === "showMediaCropModal") {
          this.showMediaModal = true;
        } else {
          this[this.info.only] = true;
          if (this.info.only === "showMediaModal") {
            this.$nextTick(() => {
              this.$refs.media.addImageClick();
            });
          }
        }
      } else {
        // 重新各种窗口打开样式
        this.showCaptionModal = this.showCommentModal = false;
        this.showMediaModal = true;
      }
      const formType = this.info.mediaType === 3 ? "story" : "post";
      if (this.model === "add") {
        // 获取当前default time 时间
        const selectPublisher = this.user.linkedInstagramList.find(
          (link) => link.publisherId === this.publisher.publisherId
        );
        let defaultTime;
        if (formType === "post") {
          defaultTime = selectPublisher.defaultPostTime;
        } else if (formType === "story") {
          defaultTime = selectPublisher.defaultPostStoryTime;
        }

        defaultTime = _.cloneDeep(defaultTime);
        // 设置默认发送时间
        this.defaultTime = lockr.get(
          `${formType}_${this.form.publisherIds[0]}`,
          {
            send: false,
          }
        );
        if (defaultTime) {
          this.defaultTime.id = `${formType}_${this.form.publisherIds[0]}`;
          this.defaultTime.tzName = defaultTime.timezone;
          this.defaultTime.open = defaultTime.enabled;
          this.defaultTime.repeat = defaultTime.repeat;
          this.defaultTime.times = defaultTime.times;
          // 判断如果类型为daliy则验证repeact time是否都开启
          if (
            defaultTime.frequencyType === 0 ||
            defaultTime.frequencyType === undefined
          ) {
            // 判断是否存在一项勾选
            const times = this.defaultTime.times.filter((t) => t.enabled);
            this.defaultTime.open = times.length > 0;
          } else {
            // 判断是否存在一项勾选
            const times = defaultTime.customFrequency.filter((c) =>
              c.times.find((t) => t.enabled)
            );
            this.defaultTime.open = times.length > 0;
          }
        }
        if (defaultTime && this.defaultTime.send && this.defaultTime.open) {
          this.form.tzName = this.defaultTime.tzName;
        }
      } else {
        this.defaultTime = false;
      }
      this.form.changeImg = this.model !== "edit";
      this.validateUrl();
      if (this.currentType) {
        this.typeOrder = [this.currentType];
      }
      // 直接搞掉所有\u2800符号还原\n 最后在变
      this.form.caption.replace(/\u2800/g, "");
    } catch (e) {
      console.error(e);
      showErrorMsg(e);
      this.close();
    } finally {
      loading.close();
    }
  },
};
</script>
